import { LiveGameContainer } from "../LiveGame/LiveGameContainer";

export function SummonerProfileLiveGamePage() {
  return (
    <div className="flex flex-col items-center w-[1016px] mt-[24px] max-md:w-full">
      <LiveGameContainer />
    </div>
  );
}
